export default "__VITE_ASSET__BQ_dH8id__"